import { html } from 'lit';
import { Sprout } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-sprout')
export class PdsIconSprout extends PdsIcon {
  @state()
  icon = Sprout;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
